import type { SynthDocument } from "../synth-designer/document";
import grandmotherSource from "./documents/grandmother.synth.json?raw";
import matriarchSource from "./documents/matriarch.synth.json?raw";

// Static assets are validated by the compiler/editor boundary and by the native-asset
// test suite. Avoid walking these large trees once more during module initialization.
export const grandmotherDocument = JSON.parse(grandmotherSource) as SynthDocument;
export const matriarchDocument = JSON.parse(matriarchSource) as SynthDocument;
